import { Card } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface InfoCardProps {
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  colorPalette?: string;
  [key: string]: any;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  description,
  children,
  colorPalette,
  ...props
}) => {
  return (
    <Card.Root colorPalette={colorPalette} {...props}>
      {(title || description) && (
        <Card.Header>
          {title && <Card.Title>{title}</Card.Title>}
          {description && <Card.Description>{description}</Card.Description>}
        </Card.Header>
      )}
      <Card.Body>{children}</Card.Body>
    </Card.Root>
  );
};
